import { JPY } from '@/constants/character';
export const numberFormatWithComma = (number: number, character?: string) => {
    const convertNumber = (number: number | null) => {
        if (!number) {
            return 0;
        }
        return new Intl.NumberFormat().format(number);
    };

    switch (character) {
        case '¥':
            if (number < 0) {
                return `-${JPY}${convertNumber(number).toString().replace('-', '')}`;
            }
            return `${JPY}${convertNumber(number)}`;
        case '￥':
            if (number < 0) {
                return `-${JPY}${convertNumber(number).toString().replace('-', '')}`;
            }
            return `${JPY}${convertNumber(number)}`;
        default:
            return `${convertNumber(number)} ${character ? character : ''}`;
    }
};
